export default __webpack_public_path__ + "static/media/image.teq2o-technologies-pvt-ltd.52ea394f.png";